import React, { useEffect, useState } from 'react'
import Modal from '.'
import * as Styled from './Modal.styles'

const ModalWithState = ({
  children = null,
  hasMegaForm = false,
  heading = null,
  modalText = '',
  showModal = false,
  size = 'lg',
  noExit = false,
  ...props
}) => {
  const [modalShowing, setModalShowing] = useState(showModal)

  return (
    <div>
      {!showModal && (
        <Styled.ModalTrigger
          role="dialog"
          tabIndex="0"
          className="leshen-modal-trigger"
          onClick={() => setModalShowing(true)}
          onKeyDown={(e) => {
            if (e.keyCode === 13 || e.keyCode === 32) {
              e.preventDefault()
              setModalShowing(true)
            }
          }}
        >
          {modalText}
        </Styled.ModalTrigger>
      )}
      <Modal
        isShowing={modalShowing}
        noExit={noExit}
        onClose={() => setModalShowing(false)}
        size={size}
        hasMegaForm={hasMegaForm}
        {...props}
      >
        {heading && <h1>{heading}</h1>}
        {children}
      </Modal>
    </div>
  )
}

const ModalWithStateWrapper = (props) => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [setMounted])

  return mounted && <ModalWithState {...props} />
}

export default ModalWithStateWrapper
